import { RouteHttpVerb } from "@devowl-wp/utils";
export const locationRestCreateCookiePolicyPost = {
    path: "/create-cookie-policy",
    method: RouteHttpVerb.POST
};
